import { render } from "./Projects.vue?vue&type=template&id=280de2b2&scoped=true&ts=true"
import script from "./Projects.vue?vue&type=script&lang=ts"
export * from "./Projects.vue?vue&type=script&lang=ts"

import "./Projects.vue?vue&type=style&index=0&id=280de2b2&lang=scss&scoped=true"

import exportComponent from "/Users/thomasplanckaert/Dedalus/GIT/carteconfituur/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280de2b2"]])

export default __exports__